import { Link } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'
import useTitle from '../../hooks/useTitle'

const Welcome = () => {

    const { id, isManager, isAdmin } = useAuth()

    useTitle(`techNotes: ${id}`)

    const date = new Date()
    const today = new Intl.DateTimeFormat('en-US', { dateStyle: 'full', timeStyle: 'long' }).format(date)

    const content = (
        <section className="welcome">

            <p>{today}</p>

            <h1>Welcome {id}!</h1>

           

            {(isManager || isAdmin) && <p><Link to="/dashboard/users">View User Settings</Link></p>}

            {(isManager || isAdmin) && <p><Link to="/dashboard/users/new">Add New User</Link></p>}

        </section>
    )

    return content
}
export default Welcome